import { apiRequest } from "./apiRequest";

export const AddNewsLetterEmail = async (post) => {

    const api = await apiRequest({
        url: "/newsletteremail",
        method: "post",
        body: post,
    });
    return api.data;
};